import React, { useEffect, useState } from "react";
import api from "../../services/api";
import Form from "../../components/form";
import { formatDateTime, formatToCurrency } from "../../helpers/helpers";
import ActionTable from "../../components/table/ActionTable";
import CustomizedSnackbars from "../../components/alert/Alert";
import { Box, Button, Grid } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import AppBar from '../appBar';
import pedidoEvento from "../../enums/pedidoEvento";
import PagamentoCartaoCredito from "./PagamentoCartaoCredito";
import socketClient from "socket.io-client";

const listaSituacao = [
  { id: 1, nome: "Em andamento (pagamento confirmado)" },
  { id: 2, nome: "Aguardando pagamento" },
  { id: 3, nome: "Enviado" },
  { id: 4, nome: "Cancelado" },
  { id: 5, nome: "Expirado" },
];

export default function AcompanhamentoPedido({match}) {
  const [notificacao, setNotificacao] = useState(null);
  const [chaveAcompanhamento] = useState(match.params.chaveAcompanhamento);
  const [compraEmProcessamento, setCompraEmProcessamento] = useState(false);
  const [pedido, setPedido] = useState({});
  const [endereco, setEndereco] = useState({});
  const [itens, setItens] = useState([]);
  const [eventos, setEventos] = useState([]);
  const [pagamentoOk, setPagamentoOk] = useState(false);
  const [msgErroRetornoPgto, setMsgErroRetornoPgto] = useState('');

  useEffect(() => {
    carregar();
  }, []);

  const notificar = (tipo, texto) => {
    setNotificacao({tipo, texto});
    setTimeout(() => setNotificacao(null), 3000);
  }

  const carregar = () => {
    api
      .get("pedidos/carregarViaChave", { chaveAcompanhamento })
      .then((pedido) => {
        pedido.codigo = pedido.id.toString().padStart(5, "0");        
        pedido.valorTotalFormat = formatToCurrency(pedido.valorTotal);
        pedido.valorFreteFormat = formatToCurrency(pedido.valorFrete);
        pedido.responsavel = `${pedido.usuarioNome} (${pedido.usuarioEmail})`;
        pedido.data = formatDateTime(pedido.dataHora, "D/M/Y h:m");
        pedido.status = pedidoEvento.desc(pedido.situacao);
        
        let valorTotalItens = 0;

        pedido.itens.forEach((item) => {
          item.valorUnitario = `R$ ${
            item.pedidoItemValor ? item.pedidoItemValor.toFixed(2) / 100 : 0
          }`;
          item.valorTotal = `R$ ${
            item.pedidoItemValor
              ? ((item.pedidoItemValor * item.pedidoItemQtd) / 100).toFixed(2)
              : 0
          }`;

          valorTotalItens += item.pedidoItemValor*item.pedidoItemQtd;
        });

        pedido.valorTotalItensFormat = formatToCurrency(valorTotalItens);

        pedido.pagamento = pedido.pagamentos[0];

        setPedido(pedido);

        pedido.eventos.forEach((evento) => {
          evento.registro = formatDateTime(evento.registro, "D/M/Y h:m");
        });

        setItens(pedido.itens);
        setEndereco(pedido.enderecoEntrega);
        setEventos(pedido.eventos);
        setCompraEmProcessamento(false);
        setMsgErroRetornoPgto('');
      })
      .catch((err) => {
        console.log("err", err);
        notificar("error", "Não foi possível exibir os dados do pedido.");
      });
  };

  const fDados = {
    title: "Dados do pedido",
    form: {
      codigo: {
        label: "Código",
        type: "text",
        space: 4,
        value: pedido.codigo,
        readOnly: true,
      },
      data: {
        label: "Data/hora",
        type: "text",
        space: 4,
        value: pedido.data,
        readOnly: true,
      },
      situacao: {
        label: "Situação",
        type: "text",
        space: 4,
        value: pedido.status,
        readOnly: true,
      },
      valorTotalItens: {
        label: "Valor total dos itens (R$)",
        type: "text",
        space: 4,
        value: pedido.valorTotalItensFormat,
        readOnly: true,
      },
      valorFrete: {
        label: "Valor do frete (R$)",
        type: "text",
        space: 4,
        value: pedido.valorFreteFormat,
        readOnly: true,
      },
      valorTotal: {
        label: "Valor total (R$)",
        type: "text",
        space: 4,
        value: pedido.valorTotalFormat,
        readOnly: true,
      },
    },
  };

  const fEscola = {
    title: "Escola",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 6,
        readOnly: true,
        value: pedido.escolaNome,
      },
      municipio: {
        label: "Município",
        type: "text",
        space: 4,
        readOnly: true,
        value: pedido.escolaMunicipio,
      },
      UF: {
        label: "UF",
        type: "text",
        space: 2,
        readOnly: true,
        value: pedido.escolaUF,
      },
      logradouro: {
        label: "Logradouro",
        type: "text",
        space: 10,
        readOnly: true,
        value: pedido.escolaEnderecoLogradouro,
      },
      numero: {
        label: "Número",
        type: "text",
        space: 2,
        readOnly: true,
        value: pedido.escolaEnderecoNumero,
      },
      CEP: {
        label: "CEP",
        type: "text",
        space: 4,
        readOnly: true,
        value: pedido.escolaEnderecoCEP,
      },
      complemento: {
        label: "Complemento",
        type: "text",
        space: 4,
        readOnly: true,
        value: pedido.escolaEnderecoComplemento,
      },
      bairro: {
        label: "Bairro",
        type: "text",
        space: 4,
        readOnly: true,
        value: pedido.escolaEnderecoBairro,
      },
    },
  };

  const tItens = {
    title: "Itens",
    columns: [
      {
        name: "produtoNome",
        label: "Produto",
      },
      {
        name: "pedidoItemQtd",
        label: "Quantidade",
      },
      {
        name: "valorUnitario",
        label: "Valor unitário",
      },
      {
        name: "valorTotal",
        label: "Valor total",
      },
    ],
    array: pedido.itens,
  };

  // const fEndereco = {
  //   title: "Entrega",
  //   form: {
  //     freteServico: {
  //       label: "Serviço de frete",
  //       type: "text",
  //       space: 12,
  //       value: pedido.freteServico,
  //       readOnly: true,
  //     },
  //     CEP: {
  //       label: "CEP",
  //       type: "text",
  //       space: 12,
  //       value: endereco.CEP,
  //       readOnly: true,
  //     },
  //     logradouro: {
  //       label: "Logradouro",
  //       type: "text",
  //       space: 6,
  //       value: endereco.logradouro,
  //       readOnly: true,
  //     },
  //     numero: {
  //       label: "Número",
  //       type: "text",
  //       space: 6,
  //       value: endereco.numero,
  //       readOnly: true,
  //     },
  //     complemento: {
  //       label: "Complemento",
  //       type: "text",
  //       space: 6,
  //       value: endereco.complemento,
  //       readOnly: true,
  //     },
  //     bairro: {
  //       label: "Bairro",
  //       type: "text",
  //       space: 6,
  //       value: endereco.bairro,
  //       readOnly: true,
  //     },
  //     municipio: {
  //       label: "Município",
  //       type: "text",
  //       space: 6,
  //       value: endereco.municipio,
  //       readOnly: true,
  //     },
  //     UF: {
  //       label: "UF",
  //       type: "text",
  //       space: 6,
  //       value: endereco.UF,
  //       readOnly: true,
  //     },
  //   },
  // };

  const tEventos = {
    title: "Eventos",
    columns: [
      {
        label: "Título",
        name: "titulo",
      },
      {
        label: "Descrição",
        name: "descricao",
      },
      {
        label: "Registro",
        name: "registro",
      },
    ],
    array: eventos,
  };

  

  const copiarCodigo = () => {
    navigator.clipboard
      .writeText(pedido.pagamento.pagamentoDiretoBoletoLinhaDigitavel)
      .then(() => {
        notificar("success", "Código copiado para a área de transferência");
      });
  };

  const baixarArquivo = () => {
    window.open(pedido.pagamento.pagamentoDiretoBoletoLinkPDF);
  };

  const registrarPagamentoCartao = (tokenCartao) => {
    setCompraEmProcessamento(true);

    const requisicao = {
        pedidoPagamentoId: pedido?.pagamento?.id,
        tokenCartao,
    }

    api.post('/pedidos/processarpagamentocartao', requisicao)
    .then(retornoPagamento => {
      if(retornoPagamento.sucesso){
        
        return carregar();
      }

      setCompraEmProcessamento(false);
      setMsgErroRetornoPgto('Não foi possível processar o pagamento. Verifique os dados informados e tente novamente.');
    })
    .catch(err => {
      setCompraEmProcessamento(false);

      const errCodes = err.data;

      console.log(err.data);

      setMsgErroRetornoPgto('Não foi possível processar o pagamento. Verifique os dados informados e tente novamente.');
    });    
  }
    
  return (
    <div>
      <AppBar/>
      {notificacao && (
        <CustomizedSnackbars
          texto={notificacao?.texto}
          tipo={notificacao?.tipo}
        ></CustomizedSnackbars>
      )}
      <div style={{padding: 10}}>
        <Form formData={fDados} />
        <Form formData={fEscola} />
        <ActionTable structure={tItens} />
        {eventos.length ? <ActionTable structure={tEventos} /> : null}
        <Box
          sx={{
            flexGrow: 1,
            // margin: 2,
            padding: 2,
            background: "white",
            // borderRadius: 2,
          }}
        >
          <Grid container spacing={2}>
            <Grid item md={12} xs={12}>
              <h4>Pagamento</h4>
              <p style={{ fontSize: "1rem" }}>
                Modalidade: {pedido.pagamento?.modalidade === 3 && "Pix"}
                {pedido.pagamento?.modalidade === 1 && "Boleto bancário"}
                {pedido.pagamento?.modalidade === 2 && "Cartão de crédito"}
              </p>
            </Grid>
            {msgErroRetornoPgto &&
              <Grid item md={12} xs={12}>
                <div style={{
                  textAlign: 'center', 
                  fontSize: 16, 
                  color: 'red'
                }}>
                    <span>{msgErroRetornoPgto}</span>
                </div>
              </Grid>
            }

            {!pedido.pagamento?.faturaPagamento && !pedido.pagamento?.pagamentoDiretoPagamento ? (
              <Grid item md={12} xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: 2,
                    background: "white",
                    padding: 2,
                    borderRadius: 2,
                    textAlign: "center",
                  }}
                >
                  {pedido.pagamento?.modalidade === 1 && (
                    <>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <h4 style={{ fontSize: "0.9rem" }}>
                          Código de barras para pagamento
                        </h4>
                      </div>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        {window.innerWidth >= 800 && (
                          <img
                            src={pedido.pagamento.pagamentoDiretoBoletoCodigoBarras}
                            alt=""
                            width={800}
                          />
                        )}
                      </div>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <div
                          style={{
                            background: "#efe3b0",
                            width: "50%",
                            padding: 10,
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                            whiteSpace: "pre-wrap",
                            overflow: "hidden",
                            textAlign: "center",
                          }}
                        >
                          {pedido.pagamento.pagamentoDiretoBoletoLinhaDigitavel}
                        </div>
                      </div>
                      <div style={{ marginTop: 10 }}>
                        <Button
                          id="myInput"
                          color="info"
                          variant="text"
                          title="Copiar código pix"
                          onClick={copiarCodigo}
                        >
                          <ContentCopyIcon />
                          copiar código
                        </Button>
                      </div>
                      <div style={{ marginTop: 10 }}>
                        <Button
                          color="primary"
                          variant="text"
                          onClick={baixarArquivo}
                        >
                          <ArrowDownwardIcon />
                          Baixar boleto
                        </Button>
                      </div>
                    </>
                  )}
                  {pedido.pagamento?.modalidade === 3 && (
                    <DadosPix
                      notificar={notificar}
                      pedido={pedido}
                      recarregarPedido={carregar}
                    />                    
                  )}
                  {pedido?.pagamento?.modalidade === 2 && (
                    <PagamentoCartaoCredito 
                      notificar={notificar} 
                      registrarPagamento={registrarPagamentoCartao}
                      compraEmProcessamento={compraEmProcessamento}
                    />
                  )}
                </Box>
              </Grid>
            ) : (
              <Grid item md={12} xs={12}>
                <div style={{backgroundColor: 'white', margin: 15, padding: 5, textAlign: 'center', borderRadius: 10}}>
                  <p>Pagamento registrado!</p>
                </div>                
              </Grid>
            )}
          </Grid>
        </Box>
      </div>
      
    </div>
  );
}

const DadosPix = ({pedido, recarregarPedido, notificar}) => {
  useEffect(() => {
    iniciarSocket();
  }, []);

  const iniciarSocket = () => {
    // const socketHost = 'http://localhost:3300';
    const socketHost = "https://pertobilingueadm.com.br";

    const socket = socketClient(socketHost, {
      // path: '/socket.io',
      path: "/pews/socket.io",
      query: {
        pedidoQuinzenaId: pedido.id,
      },
    });

    socket.on("connect_error", (err) => {
      console.log(`connect_error due to ${err.message}`);
    });

    socket.on("PIX_PAGAMENTO", () => {
      recarregarPedido();
    });
  }

  const copiarCodigo = () => {
    navigator.clipboard
      .writeText(pedido.pagamento.pagamentoDiretoPIXQRCopiaCola)
      .then(() => {
        notificar("info", "Código copiado para a área de transferência");
      });
  }

  return(
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {window.innerWidth >= 800 && (
          <img
            src={pedido.pagamento.pagamentoDiretoPIXQRCode}
            alt=""
            width={200}
            height={200}
          />
        )}
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            background: "#efe3b0",
            width: "50%",
            padding: 10,
            wordWrap: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "pre-wrap",
            overflow: "hidden",
            textAlign: "center",
            fontSize: 14
          }}
        >
          {pedido.pagamento.pagamentoDiretoPIXQRCopiaCola}
        </div>
      </div>
      <div style={{ marginTop: 10 }}>
        <Button
          id="myInput"
          color="info"
          variant="text"
          title="Copiar código pix"
          onClick={copiarCodigo}
        >
          <ContentCopyIcon />
          copiar código
        </Button>
      </div>
      <div>
        <h4 style={{ color: "#A6A6A6", fontSize: 18 }}>
          Já efetuou o pagamento?{" "}
          <span
            onClick={recarregarPedido}
            style={{
              cursor: "pointer",
              borderBottom: "2px solid #A6A6A6",
              paddingBottom: "2px",
              display: "inline-block",
            }}
          >
            Recarregar pedido
          </span>
        </h4>
      </div>
    </>
  )
}